module.exports = __webpack_public_path__ + "static/media/annamma_t_p.afce43f0.jpg";